import React, { Component } from "react";
import { Link } from "react-router-dom";

class Header extends Component {
  constructor(props) {
    super(props);
    this.navUL = React.createRef();
    this.state = {
      isNavOpen: false,
      navHeight: 0,
      showModal: false,
    };
  }

  toggleNavbar = () => {
    this.setState({
      isNavOpen: !this.state.isNavOpen,
      navHeight: this.state.navHeight > 0 ? 0 : this.navUL.current.scrollHeight,
    });
  };

  updateUserState = (e) => {
    e.preventDefault();
    this.props.toggleUserProfile();
  };

  updateCalculatorState = (e) => {
    e.preventDefault();
    this.props.toggleCalculatorProfile();
  };

  logOut = () => {
    localStorage.setItem("authenticated", false);
    localStorage.clear();
  };

  render() {
    return (
      <header>
        <div className="header-flex" style={{ backgroundColor: "#CAE4DB" }}>
          <span className="header-width-constraint">
            <button
              className="hamburger"
              type="button"
              style={{ color: `#00303F` }}
              onClick={(e) => {
                this.toggleNavbar(e);
              }}
            >
              <span
                className={
                  "hamburger-box hamburger--spin " +
                  (this.state.isNavOpen ? "is-active" : "")
                }
                style={{ color: `#00303F` }}
              >
                <span className="hamburger-inner"></span>
              </span>
            </button>
          </span>
          {/* <button
            id="profile-button"
            aria-label="Toggle User Information"
            // onClick={() => this.setState({ showModal: true })}
          >
            <Link to="/profile">
              <FontAwesomeIcon icon={faUser} style={{ fontSize: 15 }} />
            </Link>
          </button> */}
        </div>

        <nav id="site-nav">
          <ul ref={this.navUL} style={{ height: this.state.navHeight }}>
            {this.props.auth ? (
              <div>
                <li>
                  <Link
                    to="/"
                    onClick={(e) => {
                      this.toggleNavbar(e);
                    }}
                  >
                    Income
                  </Link>
                </li>
                <li>
                  <Link
                    to="/map"
                    onClick={(e) => {
                      this.toggleNavbar(e);
                    }}
                  >
                    Heat Map
                  </Link>
                </li>
                <li>
                  <Link
                    to="/profile"
                    onClick={(e) => {
                      this.toggleNavbar(e);
                    }}
                  >
                    Profile
                  </Link>
                </li>
                <li>
                  <Link
                    to="/"
                    onClick={() => {
                      this.toggleNavbar(this.props.logOut());
                    }}
                  >
                    Logout
                  </Link>
                </li>
              </div>
            ) : null}
            {!this.props.auth ? (
              <div style={{ paddingTop: "66px" }}>
                <li>
                  <Link
                    to="/login"
                    onClick={(e) => {
                      this.toggleNavbar(e);
                    }}
                  >
                    Log In
                  </Link>
                </li>
                <li>
                  <Link
                    to="/signup"
                    onClick={(e) => {
                      this.toggleNavbar(e);
                    }}
                  >
                    Sign Up
                  </Link>
                </li>
              </div>
            ) : null}
          </ul>
        </nav>
      </header>
    );
  }
}

export default Header;
